import { flushSync } from "react-dom"

import * as pagination from "@zag-js/pagination"
import { normalizeProps, useMachine } from "@zag-js/react"

import { Pagination as BasePagination } from "../../Pagination"
import { LE_TableInstance } from "../types"

export function Pagination<T extends Record<string, any> = object>({
  table,
}: {
  table: LE_TableInstance<T>
}) {
  const tableState = table.getState()
  const service = useMachine(pagination.machine, {
    id: table.tableId,
    count: tableState.total,
    onPageChange: ({ page }) => {
      flushSync(() => {
        table.setPageIndex(page - 1)
      })
    },
    pageSize: tableState.pagination.pageSize,
    page: tableState.pagination.pageIndex + 1,
  })

  const api = pagination.connect(service, normalizeProps)
  if (api.totalPages === 0) return null

  return (
    <BasePagination
      count={tableState.total}
      onStateChange={({ page, pageSize }) => {
        table.setPageSize(pageSize)
        table.setPageIndex(page - 1)
      }}
      state={{
        page: tableState.pagination.pageIndex + 1,
        pageSize: tableState.pagination.pageSize,
      }}
    />
  )
}
